import {PartyType} from '@sollapay/enums';
import {
  isFutureDate,
  validateBeneficiaryCompanyId,
  validateBeneficiaryPersonId
} from '@sollapay/utils';

import type {
  BeneficiaryRow,
  DraftBeneficiary,
  DraftErrors,
  DraftField
} from '../types/beneficiary-draft.types';
import type {PartyRole} from '@sollapay/enums';

export const EMPTY_DRAFT: DraftBeneficiary = {
  name: '',
  role: '',
  entityType: PartyType.PERSON,
  idNumber: '',
  date: '',
  address: ''
};

export const FIELD_ORDER: DraftField[] = ['name', 'role', 'idNumber', 'date', 'address'];

export const fieldElementId = (field: DraftField) => `beneficiary-draft-${field}`;

export function draftFromRow(row: BeneficiaryRow): DraftBeneficiary {
  return {
    name: row.name,
    role: row.role as PartyRole | '',
    entityType: row.entityType,
    idNumber: row.idNumber,
    date: row.date,
    address: row.address
  };
}

export function computeDraftErrors(draft: DraftBeneficiary): DraftErrors {
  const errors: DraftErrors = {};
  if (!draft.name.trim()) errors.name = 'required';
  if (!draft.role) errors.role = 'required';
  if (!draft.date) errors.date = 'required';
  else if (isFutureDate(draft.date)) errors.date = 'future_date';
  if (!draft.address.trim()) errors.address = 'required';

  const id = draft.idNumber.trim();
  if (!id) {
    errors.idNumber = 'required';
  } else if (draft.entityType === PartyType.PERSON) {
    const error = validateBeneficiaryPersonId(id);
    if (error) errors.idNumber = error;
  } else {
    const error = validateBeneficiaryCompanyId(id);
    if (error) errors.idNumber = error;
  }
  return errors;
}
